<template>
  <div class="main-view">
    <div class="add_shipping m-0 d-flex justify-content-center align-items-center" @click="btnAction('AddShipping')">
      <!-- <img src="@/assets/acrypro/LoadingBar.svg" width="30" height="30"> -->
      <svg class="add_icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon" clip-path="url(#clip0_264_1741)">
      <path id="Vector" d="M24.25 16.25H16.75V23.75H14.25V16.25H6.75V13.75H14.25V6.25H16.75V13.75H24.25V16.25Z"/>
      </g>
      <defs>
      <clipPath id="clip0_264_1741">
      <rect width="30" height="30" fill="white" transform="translate(0.5)"/>
      </clipPath>
      </defs>
      </svg>
      <span class="add_text m-3">新しい配送先を追加</span>
    </div>

    <div class="w-100 p-0 scroll gap-4" style="margin-top: 40px; height: 80%;">
      <div
        class="d-flex m-0 p-0 text-start shipping-cell"
        v-for="(data, index) in this.destinationList.filter(
          (d, i) => d.other_deliv_id != -1
        )"
        :key="index" >

        <div class="h-100" style="padding-top: 60px; width:150px;">配送先{{ index + 1 }}</div>
        <div class="h-100" style="width:80%;">
          <p class="m-0">{{ data.company_name }} {{ data.department_name }}</p>
          <p class="m-0">{{ data.name01 }}{{ data.name02 }}</p>
          <p class=""></p>
          <p class="m-0">〒{{ data.zip01 }}{{ data.zip02 }}</p>
          <p class="m-0">{{getPrefName(data.pref)}}{{ data.addr01 }}{{ data.addr02 ? data.addr02 : "" }}</p>
          <p class="m-0">{{ data.tel01 }}-{{ data.tel02 }}-{{ data.tel03 }}</p>
        </div>
        <div class="h-100 d-flex flex-column justify-content-center">
          <button class="acry-btn-primary-normal btn-size my-2" @click="editAction(data)">編集</button>
          <button class="acry-btn-secondary-normal btn-size my-2" @click="deleteAction(data)">削除</button>
        </div>
      </div>
    </div>

  </div>


</template>

<script>
import { PrefName } from "@/js/Const.js"
import { User } from "@/js/User.js";

export default {
  name: "CenterViewShippingList_Ap",
  props: {},
  data: function () {
    return {
      destinationList: [],
      deleteDelivId: 0,
    };
  },
  computed: {
  },
  async created() {
    this.$store.commit("showLoading");
    console.log("aaa");
    this.destinationList = await User.getDestinationList().catch((e) => {
      this.$common.log(e);
      this.$store.commit("showMessage", "エラーが発生しました");
    });
    this.$store.commit("hideLoading");
  },
  components: {},
  methods: {
    getPrefName(id){
      return PrefName[id];
    },

    btnAction(type) {
      this.$store.commit("setEditShippingData", null);
      this.$store.commit("setShippingScreenType", type);
    },
    editAction(data) {
      this.$store.commit("setEditShippingData", data);
      this.$store.commit("setShippingScreenType", "EditShipping");
    },

    deleteAction(data) {
      this.deleteDelivId = data.other_deliv_id;
      this.$store.commit("setYesNoDialogCallback", this.deleteProcess);
      this.$store.commit("showYesNoDialog", "配送先を削除しますか？", this.deleteProcess);
    },
    deleteProcess() {
      this.$store.commit("showLoading");
      User.deleteDestination({ other_deliv_id: this.deleteDelivId })
        .then(() => {
          User.getDestinationList()
            .then((list) => {
              this.destinationList = list;
              this.$store.commit("hideLoading");
            })
            .catch((e) => {
              this.$store.commit("hideLoading");
              this.$common.log(e);
              this.$store.commit("showMessage", "エラーが発生しました");
            });
        })
        .catch((e) => {
          this.$store.commit("hideLoading");
          this.$common.log(e);
          this.$store.commit("showMessage", "エラーが発生しました");
          return;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.main-view{
  width: 95%;
  height: 80%;
}
.add_icon{
  fill: $primary-main-color;
}
.add_shipping:hover .add_icon{
  fill: $text-white-color;
}
.add_text{
  font-family: 'Noto Sans JP';
  font-weight: bold;
  color: $primary-main-color;
}
.add_shipping:hover .add_text{
  color: $text-white-color;
}
.add_shipping {
  height: 62px;
  width: 100%;
  border: 2px dashed $border-main-color;
  border-radius: 30px;
  background-color: $background-gray-color;
}
.add_shipping:hover{
  background-color: $primary-hover-color;
}
.shipping-cell{
  width: 100%;
  height: 150px;
  border-bottom: 1px solid $border-sub-color;
  border-radius: 4px;
}
.btn-size{
  width: 160px;
  height: 38px;
}


.shippingrow {
  width: 500px;
  margin: 0 auto;
}
.scroll {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  // overflow-y: scroll;
  align-items: left;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
}
.selectedtab {
  background: #4d4f4f;
  color: white;
  font-style: bold;
}
.selectedtab:hover {
  background: #4d4f4f;
  color: white;
  text-decoration: none;
}
.unselectedtab {
  background: white;
  color: black;
  font-style: bold;
}
.btn:hover {
  color: #fff !important;
  text-decoration: none;
}
</style>
